import { render, staticRenderFns } from "./PillTag.vue?vue&type=template&id=6e366d3a"
import script from "./PillTag.vue?vue&type=script&lang=js"
export * from "./PillTag.vue?vue&type=script&lang=js"
import style0 from "./PillTag.vue?vue&type=style&index=0&id=6e366d3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports